import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook, Linkedin, MessageCircle, MapPin } from "lucide-react";
import { SITE } from "@/data/site";

const Footer = () => (
  <footer data-testid="site-footer" className="bg-ink text-rice">
    <div className="mx-auto grid max-w-6xl gap-10 px-4 py-14 sm:px-6 md:grid-cols-3">
      <div>
        <p className="font-display text-xl font-bold text-kunyit">{SITE.name}</p>
        <p className="mt-1 text-sm font-semibold uppercase tracking-[0.18em] text-rice/60">
          {SITE.tagline}
        </p>
        <p className="mt-4 max-w-sm text-sm leading-relaxed text-rice/80">
          Rumah makan masakan Minang dengan cita rasa otentik — dimasak dari
          bahan pilihan, termasuk beras Solok dari Sumatera Barat.
        </p>
        <div className="mt-5 flex gap-3">
          <a
            href={SITE.instagram}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-instagram"
            aria-label="Instagram RM. Payakumbuah"
            className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-rice/25 transition-colors hover:border-kunyit hover:text-kunyit"
          >
            <Instagram className="h-4.5 w-4.5" aria-hidden="true" />
          </a>
          <a
            href={SITE.facebook}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-facebook"
            aria-label="Facebook RM. Payakumbuah"
            className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-rice/25 transition-colors hover:border-kunyit hover:text-kunyit"
          >
            <Facebook className="h-4.5 w-4.5" aria-hidden="true" />
          </a>
          <a
            href={SITE.linkedin}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-linkedin"
            aria-label="LinkedIn RM. Payakumbuah"
            className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-rice/25 transition-colors hover:border-kunyit hover:text-kunyit"
          >
            <Linkedin className="h-4.5 w-4.5" aria-hidden="true" />
          </a>
        </div>
      </div>

      <nav aria-label="Navigasi footer">
        <p className="text-sm font-bold uppercase tracking-[0.18em] text-rice/60">
          Jelajahi
        </p>
        <ul className="mt-4 space-y-2.5 text-sm">
          {[
            ["/", "Beranda"],
            ["/menu/", "Menu"],
            ["/tentang/", "Tentang Kami"],
            ["/lokasi/", "Lokasi & Outlet"],
            ["/faq/", "Pertanyaan Umum"],
            ["/kontak/", "Kontak"],
          ].map(([to, label]) => (
            <li key={to}>
              <Link
                to={to}
                data-testid={`footer-link-${label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                className="text-rice/85 underline-offset-4 transition-colors hover:text-kunyit hover:underline"
              >
                {label}
              </Link>
            </li>
          ))}
        </ul>
      </nav>

      <div>
        <p className="text-sm font-bold uppercase tracking-[0.18em] text-rice/60">
          Hubungi Kami
        </p>
        <ul className="mt-4 space-y-3 text-sm text-rice/85">
          <li>
            <a
              href={SITE.wa.href}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-wa"
              className="inline-flex items-center gap-2 underline-offset-4 hover:text-kunyit hover:underline"
            >
              <MessageCircle className="h-4 w-4" aria-hidden="true" />
              {SITE.wa.label} ({SITE.wa.note})
            </a>
          </li>
          <li>
            <a
              href={SITE.waPartner.href}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-wa-partner"
              className="inline-flex items-center gap-2 underline-offset-4 hover:text-kunyit hover:underline"
            >
              <MessageCircle className="h-4 w-4" aria-hidden="true" />
              {SITE.waPartner.label} ({SITE.waPartner.note})
            </a>
          </li>
          <li className="flex items-start gap-2">
            <MapPin className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" />
            <span>{SITE.address}</span>
          </li>
        </ul>
      </div>
    </div>
    <div className="border-t border-rice/15 py-5 text-center text-xs text-rice/50">
      © {SITE.company} — {SITE.name}. Seluruh hak cipta dilindungi.
    </div>
  </footer>
);

export default Footer;
